import { useEffect, useState } from "react";
import { Link, useRouteError } from "react-router";
import { RefreshCw } from "lucide-react";
import { TheAdamMark } from "@/components/brand";
import { Button } from "@/components/ui/button";
import { isChunkError, reloadOnce } from "@/lib/reload";

/** Sayfa yüklenirken / çizilirken hata: yeni sürüm kaynaklıysa kendini yeniler, değilse sade bir ekran. */
export function RouteError() {
  const error = useRouteError();
  const chunk = isChunkError(error);
  const [reloading, setReloading] = useState(chunk);
  useEffect(() => {
    if (chunk && !reloadOnce()) setReloading(false);
  }, [chunk]);

  if (reloading) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 p-6 text-center text-sm text-muted-foreground">
        <RefreshCw className="size-5 animate-spin text-accent" aria-hidden />
        Panelin yeni sürümü yükleniyor…
      </div>
    );
  }
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-6 p-6 text-center">
      <TheAdamMark />
      <div>
        <h1 className="text-xl font-semibold">{chunk ? "Panel güncellendi" : "Bu sayfa açılamadı"}</h1>
        <p className="mt-2 max-w-md text-sm text-muted-foreground">
          {chunk ? "Panelin yeni sürümü yayında. Devam etmek için sayfayı yenileyin." : "Beklenmeyen bir hata oluştu. Sayfayı yenileyin; sorun sürerse Ayarlar → Öneriler'den bildirin."}
        </p>
      </div>
      <div className="flex gap-2">
        <Button onClick={() => window.location.reload()}>
          <RefreshCw /> Sayfayı yenile
        </Button>
        <Button asChild variant="outline">
          <Link to="/">Genel bakışa dön</Link>
        </Button>
      </div>
    </div>
  );
}
